import { useCallback } from 'react';

import { Container, LeftSection, RightSection, StickyPageHeaderSkeletonWithButtons } from '@/_containers';
import { SecondaryPageLayoutLoading } from '@/_containers/layout/secondary-page-layout';
import AddendumLoading from '@/_pages/agreements/addendums/loading';
import ApiIntegrationLoading from '@/_pages/agreements/api-integration/loading';
import DeliverablesLoading from '@/_pages/agreements/deliverables/loading';
import ExecutionLoading from '@/_pages/agreements/execution/loading';
import PaperworkLoading from '@/_pages/agreements/paperwork/loading';
import ProfileLoading from '@/_pages/agreements/profile/loading';
import { ProfileRightSectionLoading } from '@/_pages/agreements/profile/right-section';
import { HeaderLoading } from '@/_pages/agreements/shared/components/header-section';
import { agreementsSubNav, useCurrentLocation } from '@/_shared';

export function TemplateLoading() {
  const { matched } = useCurrentLocation();
  const { tabKey, renderRightColumn } = matched?.staticData ?? {};

  const render = useCallback(() => {
    switch (tabKey) {
      case 'agreement/addendum':
        return <AddendumLoading />;
      case 'agreement/api-integration':
        return <ApiIntegrationLoading />;
      case 'agreement/deliverables':
        return <DeliverablesLoading />;
      case 'agreement/execution':
        return <ExecutionLoading />;
      case 'agreement/paperwork':
        return <PaperworkLoading />;
      case 'agreement/profile':
      default:
        return <ProfileLoading />;
    }
  }, [tabKey]);

  return (
    <SecondaryPageLayoutLoading subNavLinks={agreementsSubNav}>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} allowBack />
      <Container>
        <LeftSection forceFullWidth={matched?.staticData?.isFullWidth}>
          <HeaderLoading />
          {render()}
        </LeftSection>
        {renderRightColumn && (
          <RightSection>
            <ProfileRightSectionLoading />
          </RightSection>
        )}
      </Container>
    </SecondaryPageLayoutLoading>
  );
}
